const $ = require('jquery')

module.exports = (function () {
  /*
   * $(".js-project-create-modal").viewManager(function(){
   *     var $childFormElm = this.$el.find("form");
   * });
   * jsで操作する範囲を明確にするために使うプラグイン。
   */
  $.fn.extend({
    viewManager: function (callback) {
      this.$el = $(this)
      callback.call(this)
    }
  })
})()
